import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { BehalfOfOptions, userTypes } from "../../../constants/options";

function YourInformation({
  fields,
  utilities,
}) {

  const {
    createWizInput,
    createToggleInput,
    createWizSelect
  } = utilities;

  return (
    <div>
      <PageWrapper legendInfo="Your Information:" required={true}>
        <div className={Styles.labelInputContainer}>
          <div className={Styles.inputContainer}>
            {createWizInput(
              fields.contactFirstName,
              "100%",
              Styles.anonInput
              )}
            {createWizInput(
              fields.contactLastName,
              "100%",
              Styles.anonInput
            )}
          </div>
          <div className={Styles.inputContainer}>
            {createWizInput(
              fields.contactEmail,
              "100%",
              Styles.anonInput
            )}
            {createWizInput(
              fields.confirmEmail,
              "100%",
              Styles.anonInput
            )}
          </div>
          <div className={Styles.inputContainer}>
            {createWizInput(
              fields.contactPhone,
              "50%",
              Styles.anonInput,
              "tel"
            )}
          </div>
        </div> 
        {createToggleInput(fields.userType, "100%", userTypes, true)}
        {fields.userType.value === userTypes[1].value && <>
        {createWizSelect(fields.onBehalfOf, "70%", BehalfOfOptions, Styles.anonSelect, "", { punctuate: ":", isRow: true} )}
          {fields.onBehalfOf.value === BehalfOfOptions[1] &&
           <div className={Styles.labelInputContainer}>
           <p
             style={{
               fontWeight: 600,
               paddingRight: ".5rem",
               paddingTop: "1rem",
               fontSize: ".9rem",
             }}
           >
             Who is the third-party claimant?
           </p>
           <div className={Styles.inputContainer}>
            {createWizInput(fields.behalfOfFirst, "100%", Styles.anonInput)}
            {createWizInput(fields.behalfOfLast, "100%", Styles.anonInput)}
           </div>
         </div>
          }
        </>
        }
      </PageWrapper>
    </div>
  );
}

export default YourInformation;
